import React from 'react';

const repeats = Array.from(Array(3).keys());
export const WidgetLoading = () => (
	<div>
		<style>
			{`
			.widget-loading,
			.widget-loading *,
			.widget-loading *::before,
			.widget-loading *::after { 
				box-sizing: border-box; 
			}
			.widget-loading {
				font-family: 'Inter', sans-serif;
				max-width: min(var(--pushpay-widget-width, 408px), 1400px);
				min-width: 400px;
				flex-grow: 1;
				height: 600px;
				border-radius: 5px;
				margin: auto;
				padding: 24px;
				background-color: #ffffff;
				box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.1);
			}

			.widget-loading-title {
				margin: 0;
				margin-bottom: 24px;
				border-radius: 4px;
			}

			.widget-loading-label:after,
			.widget-loading-output:after,
			.widget-loading-button:after,
			.widget-loading-input:after {
				content: '';
				position: absolute;
				top: 0px;
				left: 0px;
				right: 0px;
				width: 0px;
				bottom: 0px;
				height: 40px;
				overflow: hidden;
				background-image: linear-gradient(to left, #E1E3E9 25%, #cacbd1 40%, #E1E3E9 80%);
				animation: shimmer-row 2s infinite;
			}

			.widget-loading-label:after {
				height: 20px;
			}
			.widget-loading-output:after,
			.widget-loading-input:after {
				height: 44px;
			}

			.widget-loading-wrap {
				position: relative;
				display: block;
				padding-bottom: 24px;
			}

			.widget-loading-label,
			.widget-loading-input,
			.widget-loading-output,
			.widget-loading-button {
				position: relative;
				width: 200px;
				border-radius: 100px;
				margin-bottom: 8px;
				background-color: #E1E3E9;
				height: 20px;
				flex: 1 1 auto;
				overflow: hidden;
			}

			.widget-loading-label {
				width: 200px;
				border-radius: 100px;
				margin-bottom: 8px;
			}

			.widget-loading-output,
			.widget-loading-input {
				height: 44px;
				width: 100%;
				margin-bottom: 8px;
				border-radius: 4px;
			}

			.widget-loading-output {
				margin-bottom: 0;
			}

			.widget-loading-button {
				height: 40px;
				width: 100%;
				border-radius: 100px;
			}

			.widget-powered-by {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 16px;
				font-size: 12px;
				color: #91949C;
			}

			.widget-loading-img {
				margin-left: 8px;
			}

			@keyframes shimmer-row {
				100% {
					width: 200%;
				}
			}

			@media only screen and (max-width: 600px) {
				.widget-loading {
					width: 100%;
					max-width: unset;
					min-width: unset;
				}
			}
		`}
		</style>
		<div className="widget-loading">
			<h5 className="widget-loading-title">Give now</h5>
			{repeats.map(i => (
				<div key={i} className="widget-loading-wrap">
					<div className="widget-loading-label" />
					<div className="widget-loading-input" />
					<div className="widget-loading-output" />
				</div>
			))}
			<div className="widget-loading-button" />
			<div className="widget-powered-by">
				Powered by
				<img
					alt="Pushpay logo"
					className="widget-loading-img"
					src="data:image/png;base64,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"
					width="58"
				/>
			</div>
		</div>
	</div>
);

export default WidgetLoading;
